import React, { useState, useEffect, useCallback } from 'react';

const API_URL = '';
const fmt = (iso) => iso ? new Date(iso).toLocaleString('hi-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—';

export const BookingsPanel = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/bookings`);
      setRows((await res.json()).bookings || []);
    } catch (e) { console.error(e); }
    setLoading(false);
  }, []);
  useEffect(() => { load(); }, [load]);

  const markDone = async (id) => {
    await fetch(`${API_URL}/api/admin/bookings/${id}`, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ status: 'scheduled' }) });
    load();
  };

  return (
    <div className="mb-4 bg-white rounded-xl shadow p-4" data-testid="bookings-panel">
      <h3 className="text-lg font-bold text-gray-800 mb-3">📅 Bookings (₹5100 Call / ₹51000 भेंट)</h3>
      {loading ? <div className="text-center py-6 text-gray-400">Loading...</div>
        : rows.length === 0 ? <div className="text-center py-6 text-gray-400">अभी कोई call/भेंट booking नहीं है</div>
        : (
        <div className="overflow-x-auto"><table className="w-full text-sm">
          <thead><tr className="text-left text-gray-500 text-xs uppercase"><th className="p-2">Customer</th><th className="p-2">सेवा</th><th className="p-2">राशि</th><th className="p-2">Paid</th><th className="p-2">Status</th></tr></thead>
          <tbody>{rows.map((b, i) => (
            <tr key={b.id} className="border-t border-gray-100" data-testid={`booking-row-${i}`}>
              <td className="p-2 font-bold text-gray-800">{b.name}<div className="text-xs text-gray-400 font-normal">{b.mobile1}</div></td>
              <td className="p-2">{b.payment_service === 'call' ? '📞 30-min Call' : '🏛 व्यक्तिगत भेंट'}</td>
              <td className="p-2 font-bold text-emerald-600">₹{b.payment_amount}</td>
              <td className="p-2 text-gray-500">{fmt(b.paid_at)}</td>
              <td className="p-2">{b.booking_status === 'scheduled'
                ? <span className="text-green-600 font-bold">✓ Scheduled</span>
                : <button onClick={() => markDone(b.id)} className="px-3 py-1 bg-amber-500 text-white rounded-lg text-xs font-bold" data-testid={`booking-schedule-btn-${i}`}>⏰ Schedule बाकी</button>}</td>
            </tr>))}</tbody>
        </table></div>)}
    </div>
  );
};

export const FailedMsgPanel = () => {
  const [data, setData] = useState(null);
  const [health, setHealth] = useState(null);
  useEffect(() => {
    fetch(`${API_URL}/api/admin/wa-failed`).then(r => r.json()).then(setData).catch(console.error);
    fetch(`${API_URL}/api/admin/wa-health`).then(r => r.json()).then(setHealth).catch(console.error);
  }, []);
  if (!data) return <div className="mb-4 bg-white rounded-xl shadow p-4 text-center text-gray-400">Loading...</div>;
  const { delivery_failures = [], send_failures = [] } = data;
  const configBroken = health && (!health.template_fetch_ok || !health.report_template);
  return (
    <div className="mb-4 bg-white rounded-xl shadow p-4" data-testid="failed-msg-panel">
      <h3 className="text-lg font-bold text-gray-800 mb-3">⚠️ Failed WhatsApp Messages</h3>
      {health && (
        <div className={`mb-3 p-3 rounded-lg border text-sm ${configBroken ? 'bg-red-50 border-red-300' : 'bg-emerald-50 border-emerald-200'}`} data-testid="wa-health-strip">
          {configBroken ? (
            <div className="font-bold text-red-700">🚨 WhatsApp config समस्या — templates fetch नहीं हो रहे (WABA {health.waba_tail || '?'})। Report sends रुके हैं!</div>
          ) : (
            <div className="flex flex-wrap gap-x-4 gap-y-1 text-gray-700">
              <span>✅ Template: <b>{health.report_template}</b></span>
              <span>Approved: <b>{health.approved_templates}</b></span>
              <span>आज sent: <b className="text-emerald-700">{health.sent_today}</b></span>
              <span>Queue due: <b className={health.counts?.scheduled_due > 5 ? 'text-red-600' : ''}>{health.counts?.scheduled_due ?? 0}</b></span>
              <span>आगे scheduled: <b>{health.counts?.scheduled_future ?? 0}</b></span>
              <span>Worker: <b>{health.worker?.last_run ? fmt(health.worker.last_run) : '⚠️ नहीं चला'}</b></span>
              {health.phone_quality?.quality_rating && (
                <span data-testid="wa-quality-badge">Number Quality: <b className={
                  health.phone_quality.quality_rating === 'GREEN' ? 'text-emerald-600' :
                  health.phone_quality.quality_rating === 'YELLOW' ? 'text-amber-600' : 'text-red-600'
                }>{health.phone_quality.quality_rating === 'GREEN' ? '🟢 GREEN' : health.phone_quality.quality_rating === 'YELLOW' ? '🟡 YELLOW' : '🔴 ' + health.phone_quality.quality_rating}</b></span>
              )}
            </div>
          )}
          {health.phone_quality?.quality_rating === 'RED' && (
            <div className="mt-2 p-2 bg-red-100 border border-red-300 rounded-lg text-red-700 font-bold text-xs" data-testid="wa-quality-red-warning">
              🚨 WhatsApp number quality RED है — ban का खतरा! Marketing/bulk messages बिल्कुल न भेजें, कुछ दिन सिर्फ ज़रूरी UTILITY messages जाने दें ताकि rating recover हो।
              <div className="mt-1 font-normal">🛡 Auto-protection ON: marketing offers blocked, report sends धीमे (3/min) — quality GREEN होते ही अपने-आप normal हो जाएगा।</div>
            </div>
          )}
        </div>
      )}
      {delivery_failures.length === 0 && send_failures.length === 0 ? (
        <div className="text-center py-6 text-green-600 font-bold">✓ कोई failed message नहीं — सब deliver हो रहे हैं</div>
      ) : (
        <div className="space-y-3">
          {delivery_failures.map((f, i) => (
            <div key={f.id || i} className="p-3 bg-red-50 rounded-lg border border-red-200 text-sm" data-testid={`fail-delivery-${i}`}>
              <b className="text-red-700">Delivery Fail</b> · {f.phone} · <span className="text-gray-500">{fmt(f.at)}</span>
              <div className="text-xs text-red-600 mt-1">{f.error}</div>
            </div>))}
          {send_failures.map((f, i) => (
            <div key={f.id} className="p-3 bg-amber-50 rounded-lg border border-amber-200 text-sm" data-testid={`fail-send-${i}`}>
              <b className="text-amber-700">{f.name}</b> ({f.mobile1})
              <div className="text-xs text-gray-600 mt-1">
                {f.wa_report_status === 'failed' && <div>Report: {f.wa_report_error}</div>}
                {f.wa_reminder1_status?.startsWith('failed') && <div>Reminder-1: {f.wa_reminder1_status}</div>}
                {f.wa_reminder2_status?.startsWith('failed') && <div>Reminder-2: {f.wa_reminder2_status}</div>}
              </div>
            </div>))}
        </div>
      )}
    </div>
  );
};
